import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { cleanupStockSelectionLocks } from "../../components/Api/GmsStockSelectionLock";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      // Cleanup stock selection locks for this user before logout
      try {
        const userId = localStorage.getItem("userId");
        if (userId) {
          // Cleanup locks older than 0 hours (all locks, since cutoff date will be current time)
          // This ensures we delete all locks regardless of when they were created
          await cleanupStockSelectionLocks(0).catch(err => {
            console.warn('Failed to cleanup stock locks on logout:', err);
            // Don't block logout if cleanup fails
          });
        }
      } catch (error) {
        console.warn('Error during stock lock cleanup on logout:', error);
        // Don't block logout if cleanup fails
      }
      
      // Clear all authentication data
      localStorage.removeItem("authUser");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("token");
      localStorage.removeItem("branchId");
      localStorage.removeItem("userBranchId");
      localStorage.removeItem("branchName");
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("RefreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("userRights");
      localStorage.removeItem("IsMainStore");
      localStorage.removeItem("employeeId");
      localStorage.removeItem("EmployeeNumber");
      localStorage.removeItem("UnsavedItems");
      localStorage.removeItem("IsWholesale");
      localStorage.removeItem("refreshTokenInProgress");

      // Replace current history entry with login page to prevent back button
      window.history.replaceState(null, "", "/login");
      
      // Navigate to login page
      navigate("/login", { replace: true });
    };
    
    performLogout();
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default Logout; 